<template>
  <div class="paging-list">
    <vs-table ref="table" :pagination="pagination && (data.length > limit)" :max-items="limit" :data="data" 
      v-bind="{data, value, color, stripe, hoverFlat, maxHeight, multiple, notSpacer, search, noDataText}"
      @input="onChange"
      @selected="onSelected"
    >
      <template slot="header">
        <slot name="header" />
      </template>
      <template slot="thead">
        <slot name="thead" />
      </template>
      <template slot="tbody">
        <slot name="tbody" />
      </template>

      <template slot-scope="scope">
        <tbody>
          <slot v-bind="scope" />
        </tbody>
      </template>
     </vs-table>
     <vs-pagination v-if="pagination" class="mt-5" :total="totalPage" :value="page" @change="pageChange"></vs-pagination>
   </div>
</template>
<script>

export default {
  name: 'paging-list',
  props: {
    value:{},
    color: {
      default:'primary',
      type: String
    },
    noDataText: {
      default: '暂无数据',
      type: String
    },
    stripe:{
      default: false,
      type: Boolean
    },
    hoverFlat:{
      default: false,
      type: Boolean
    },
    maxHeight:{
      default: 'auto',
      type: String
    },
    multiple:{
      default: false,
      type: Boolean
    },
    data:{
      default: null,
    },
    notSpacer:{
      default:false,
      type:Boolean
    },
    search:{
      default: false,
      type: Boolean
    },
    pagination:{
      default: true,
      type: Boolean
    },
    total: {
      type: Number,
      default: 0,
    },
    limit: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 1,
    },
    onPageChange: {
      type: Function,
      default: () => {}
    }
  },
  watch: {
    page(n) {
      this.currentPage = n
    },
  },
  computed: {
    totalPage() {
      return Math.ceil(this.total / this.limit) || 1
    }
  },
  methods: {
    pageChange(n) {
      this.onPageChange(n)
      this.$emit('pageChange', n)
    },
    onChange(e) {
      this.$emit('input', e)
    },
    onSelected(e) {
      this.$emit('selected', e)
    }
  }
}
</script>